angular
	.module 'App.Value'
	.value 'kebabCaseToSnakeCase', (string) ->
		return string.split('-').join('_')
